export default __webpack_public_path__ + "static/media/green-mass-data.ebff462c.svg";